<template>
  <div id="assignment_selection_modal" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-margin-auto-vertical">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">{{ $t('general.select_assignment') }}</h2>
      </div>
      <div class="uk-modal-body">
        <!-- Search Input -->
        <div class="search-section mb-3">
          <search-input v-model="searchQuery" @search="handleSearch"/>
        </div>
        
        <default-loading v-if="loading"></default-loading>
        <template v-else>
          <table 
            class="uk-table uk-table-middle uk-table-divider"
            v-if="assignmentList && assignmentList.length > 0"
          >
            <thead>
              <tr>
                <th>{{ $t('general.assignment_name') }}</th>
                <th>{{ $t('general.end_date') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(assignment, index) in assignmentList" :key="index">
                <td>{{ assignment.name }}</td>
                <td>{{ assignment.end_date }}</td>
                <td class="text-right">
                  <button 
                    @click="selectAssignment(assignment.id)" 
                    class="uk-button uk-button-default"
                    type="button"
                  >
                    {{ $t('general.assign') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          
          <!-- Pagination -->
          <pagination v-if="paginationData" :pagination="paginationData"
                      class="mt-3 mb-2" @changePage="handlePageChange" />
          
          <div class="uk-alert-warning" uk-alert v-else-if="!assignmentList || assignmentList.length === 0">
            <p>{{ $t('general.no_assignments_available') }}</p>
          </div>
        </template>
      </div>
      <div class="uk-modal-footer d-flex justify-content-end">
        <a href="javascript:;" class="btn btn-danger uk-modal-close">
          {{ $t("general.close") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import SearchInput from "@/view/components/inputs/SearchInput.vue";

export default {
  name: "AssignmentSelectionModal",
  components: {
    DefaultLoading,
    Pagination,
    SearchInput
  },
  props: {
    assignmentData: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: ''
    };
  },
  computed: {
    assignmentList() {
      return this.assignmentData?.data || [];
    },
    paginationData() {
      if (!this.assignmentData) return null;

      return { ...this.assignmentData };
    }
  },
  methods: {
    selectAssignment(assignmentId) {
      this.$emit('assignment-selected', assignmentId);
    },
    handlePageChange(page) {
      this.$emit('page-changed', page);
    },
    handleSearch(searchValue) {
      this.$emit('search-changed', searchValue);
    }
  }
};
</script>

<style scoped>
.uk-modal-dialog {
  max-width: 800px;
}

.uk-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.search-section {
  padding: 0;
}

.uk-table {
  margin-bottom: 0;
}

.uk-button-default {
  transition: all 0.3s ease;
}

.uk-button-default:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
}

/* Pagination styling inside modal */
::v-deep .pagination {
  margin-bottom: 0;
}

::v-deep .pagination .page-link {
  font-size: 14px;
  padding: 0.375rem 0.75rem;
}
</style>